__turbopack_context__.v({
  "bgBlobDesktop": "EmptyList-module-scss-module__FuEi9a__bgBlobDesktop",
  "bgBlobMobile": "EmptyList-module-scss-module__FuEi9a__bgBlobMobile",
  "body": "EmptyList-module-scss-module__FuEi9a__body",
  "buttonInline": "EmptyList-module-scss-module__FuEi9a__buttonInline",
  "buttonWrapper": "EmptyList-module-scss-module__FuEi9a__buttonWrapper",
  "coffeeStickerOverflow": "EmptyList-module-scss-module__FuEi9a__coffeeStickerOverflow",
  "content": "EmptyList-module-scss-module__FuEi9a__content",
  "description": "EmptyList-module-scss-module__FuEi9a__description",
  "emptyList": "EmptyList-module-scss-module__FuEi9a__emptyList",
  "headline": "EmptyList-module-scss-module__FuEi9a__headline",
});
